export const GET_ITEMS = 'GET_ITEMS';
export const ADD_ITEM = 'ADD_ITEM';
export const DELETE_ITEM = 'DELETE_ITEM';
export const ITEMS_LOADING = 'ITEMS_LOADING';
export const USER_LOADING = "USER_LOADING";
export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const GET_ERRORS = 'GET_ERRORS';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const REFRESH_AUTH_TOKEN = 'REFRESH_AUTH_TOKEN';

export const POST_SUGGESTION = 'POST_SUGGESTION';

export const GET_CLIENTS = 'GET_CLIENTS';
export const GET_SPECIFIC_CLIENT = 'GET_SPECIFIC_CLIENT';
export const ADD_CLIENT = 'ADD_CLIENT';
export const EDIT_CLIENT = 'EDIT_CLIENT';
export const DELETE_CLIENT = 'DELETE_CLIENT';
export const CLEAR_CLIENTS = 'CLEAR_CLIENTS';
export const CLIENTS_LOADING = 'CLIENTS_LOADING';
export const ADD_TABLE_CLIENT = 'ADD_TABLE_CLIENT';
export const DELETE_TABLE_CLIENT = 'DELETE_TABLE_CLIENT';
export const CLEAR_TABLE_CLIENTS = 'CLEAR_TABLE_CLIENTS';

export const GET_PROSPECTS = 'GET_PROSPECTS';
export const GET_SPECIFIC_PROSPECT = 'GET_SPECIFIC_PROSPECT';
export const ADD_PROSPECT = 'ADD_PROSPECT';
export const EDIT_PROSPECT = 'EDIT_PROSPECT';
export const DELETE_PROSPECT = 'DELETE_PROSPECT';
export const CLEAR_PROSPECTS = 'CLEAR_PROSPECTS';
export const PROSPECTS_LOADING = 'PROSPECTS_LOADING';

export const GET_VISITORS = 'GET_VISITORS';
export const GET_SPECIFIC_VISITOR = 'GET_SPECIFIC_VISITOR';
export const ADD_VISITOR = 'ADD_VISITOR';
export const EDIT_VISITOR = 'EDIT_VISITOR';
export const DELETE_VISITOR = 'DELETE_VISITOR';
export const CLEAR_VISITORS = 'CLEAR_VISITORS';
export const VISITORS_LOADING = 'VISITORS_LOADING';

export const GET_SOCIETES = 'GET_SOCIETES';
export const ADD_SOCIETE = 'ADD_SOCIETE';
export const DELETE_SOCIETE = 'DELETE_SOCIETE';
export const CLEAR_SOCIETES = 'CLEAR_SOCIETES';
export const SOCIETES_LOADING = 'SOCIETES_LOADING';

export const GET_SOCIETE_GROUPS = 'GET_SOCIETE_GROUPS';
export const CLEAR_SOCIETE_GROUPS = 'CLEAR_SOCIETE_GROUPS';
export const SOCIETE_GROUPS_LOADING = 'SOCIETE_GROUPS_LOADING';

export const GET_BIENS = 'GET_BIENS';
export const GET_SPECIFIC_BIEN = 'GET_SPECIFIC_BIEN';
export const ADD_BIEN = 'ADD_BIEN';
export const EDIT_BIEN = 'EDIT_BIEN';
export const DELETE_BIEN = 'DELETE_BIEN';
export const CLEAR_BIENS = 'CLEAR_BIENS';
export const CLEAR_SPECIFIC_BIEN = 'CLEAR_SPECIFIC_BIEN';
export const BIENS_LOADING = 'BIENS_LOADING';
export const UPDATE_BIEN_DOA = 'UPDATE_BIEN_DOA';
export const UPDATE_BIEN_DIVISION = 'UPDATE_BIEN_DIVISION';
export const BIEN_VENDU = 'BIEN_VENDU';

export const GET_ENCAISSEMENTS = 'GET_ENCAISSEMENTS';
export const GET_ENCAISSEMENTS_BY_USER = 'GET_ENCAISSEMENTS_BY_USER';
export const GET_ENCAISSEMENTS_FOR_COMMISSION = 'GET_ENCAISSEMENTS_FOR_COMMISSION';
export const GET_REMAINING_ENCAISSEMENTS = 'GET_REMAINING_ENCAISSEMENTS';
export const GET_PTF_V_ENCAISSEMENTS = 'GET_PTF_V_ENCAISSEMENTS';
export const GET_PTF_ANPV_ENCAISSEMENTS = 'GET_PTF_ANPV_ENCAISSEMENTS';
export const GET_PTF_DELAY_ENCAISSEMENTS = 'GET_PTF_DELAY_ENCAISSEMENTS';
export const GET_PTF_BV_ENCAISSEMENTS = 'GET_PTF_BV_ENCAISSEMENTS';
export const GET_PTF_S_ENCAISSEMENTS = 'GET_PTF_S_ENCAISSEMENTS';
export const GET_PTF_COMPTA_ENCAISSEMENTS = 'GET_PTF_COMPTA_ENCAISSEMENTS';
export const GET_PTF_C_ENCAISSEMENTS = 'GET_PTF_C_ENCAISSEMENTS';
export const GET_RAP_ENCAISSEMENTS = 'GET_RAP_ENCAISSEMENTS';
export const GET_EI_ENCAISSEMENTS = 'GET_EI_ENCAISSEMENTS';
export const GET_ENCAISSEMENT_REPLACMENT = 'GET_ENCAISSEMENT_REPLACMENT';
export const GET_SPECIFIC_ENCAISSEMENT = 'GET_SPECIFIC_ENCAISSEMENT';
export const ADD_ENCAISSEMENT = 'ADD_ENCAISSEMENT';
export const ADD_ENCAISSEMENTS_TO_VENTE = 'ADD_ENCAISSEMENTS_TO_VENTE';
export const EDIT_ENCAISSEMENT = 'EDIT_ENCAISSEMENT';
export const ENCAISSEMENTS_STATUT_PTF_BV = 'ENCAISSEMENTS_STATUT_PTF_BV';
export const DELETE_ENCAISSEMENT = 'DELETE_ENCAISSEMENT';
export const CLEAR_ENCAISSEMENTS = 'CLEAR_ENCAISSEMENTS';
export const CLEAR_REMAINING_ENCAISSEMENTS = 'CLEAR_REMAINING_ENCAISSEMENTS';
export const ENCAISSEMENTS_LOADING = 'ENCAISSEMENTS_LOADING';

export const GET_ENCAISSEMENT_LINES = 'GET_ENCAISSEMENT_LINES';
export const ADD_ENCAISSEMENT_LINE = 'ADD_ENCAISSEMENT_LINE';
export const DELETE_ENCAISSEMENT_LINE = 'DELETE_ENCAISSEMENT_LINE';
export const CLEAR_ENCAISSEMENT_LINES = 'CLEAR_ENCAISSEMENT_LINES';

export const GET_BANQUE_VERSEMENTS = 'GET_BANQUE_VERSEMENTS';
export const ADD_BANQUE_VERSEMENT = 'ADD_BANQUE_VERSEMENT';
export const DELETE_BANQUE_VERSEMENT = 'DELETE_BANQUE_VERSEMENT';
export const CLEAR_BANQUE_VERSEMENTS = 'CLEAR_BANQUE_VERSEMENTS';
export const BANQUE_VERSEMENTS_LOADING = 'BANQUE_VERSEMENTS_LOADING';

export const GET_BANKS = 'GET_BANKS';
export const ADD_BANK = 'ADD_BANK';
export const DELETE_BANK = 'DELETE_BANK';
export const CLEAR_BANKS = 'CLEAR_BANKS';
export const BANKS_LOADING = 'BANKS_LOADING';

export const GET_PROMOTEURS = 'GET_PROMOTEURS';
export const CLEAR_PROMOTEURS = 'CLEAR_PROMOTEURS';
export const PROMOTEURS_LOADING = 'PROMOTEURS_LOADING';

export const GET_USERS = 'GET_USERS';
export const GET_SPECIFIC_USER = 'GET_SPECIFIC_USER';
export const ADD_USER = 'ADD_USER';
export const EDIT_USER = 'EDIT_USER';
export const EDIT_USER_PASSWORD = 'EDIT_USER_PASSWORD';
export const EDIT_PRIVILEGES = 'EDIT_PRIVILEGES';
export const DELETE_USER = 'DELETE_USER';
export const CLEAR_USERS = 'CLEAR_USERS';
export const USERS_LOADING = 'USERS_LOADING';

export const GET_VENTES = 'GET_VENTES';
export const GET_VENTES_BY_USER = 'GET_VENTES_BY_USER';
export const GET_VENTES_BY_CHARGE = 'GET_VENTES_BY_CHARGE';
export const GET_SPECIFIC_VENTE = 'GET_SPECIFIC_VENTE';
export const CLEAR_SPECIFIC_VENTE = 'CLEAR_SPECIFIC_VENTE';
export const ADD_VENTE = 'ADD_VENTE';
export const DELETE_VENTE = 'DELETE_VENTE';
export const CLEAR_VENTES = 'CLEAR_VENTES';
export const VENTES_LOADING = 'VENTES_LOADING';
export const UPLOAD_RECU = 'UPLOAD_RECU';
export const UPLOAD_CONTRAT_SIGNE = 'UPLOAD_CONTRAT_SIGNE';
export const DO_DT = 'DO_DT';
export const EDIT_VENTE_CHARGE = 'EDIT_VENTE_CHARGE';
export const EDIT_VENTE_COMMISSIONED_TO = 'EDIT_VENTE_COMMISSIONED_TO';
export const EDIT_VENTE_PROMOTEUR = 'EDIT_VENTE_PROMOTEUR';
export const EDIT_VENTE_BIEN_PRICE = 'EDIT_VENTE_BIEN_PRICE';
export const EDIT_VENTE = 'EDIT_VENTE';

export const GET_ASSOCIATIONS = 'GET_ASSOCIATIONS';
export const GET_ASSOCIATIONS_BY_USER = 'GET_ASSOCIATIONS_BY_USER';
export const GET_ASSOCIATIONS_BY_CHARGE = 'GET_ASSOCIATIONS_BY_CHARGE';
export const EDIT_ASSOCIATION = 'EDIT_ASSOCIATION';
export const ASSOCIATIONS_LOADING = 'ASSOCIATIONS_LOADING';
export const CLEAR_ASSOCIATIONS = 'CLEAR_ASSOCIATIONS';

export const GET_DOAS = 'GET_DOAS';
export const GET_SPECIFIC_DOA = 'GET_SPECIFIC_DOA';
export const ASK_DOA = 'ASK_DOA';
export const ANSWER_DOA = 'ANSWER_DOA';
export const DELETE_DOA = 'DELETE_DOA';
export const CLEAR_DOAS = 'CLEAR_DOAS';
export const DOAS_LOADING = 'DOAS_LOADING';

export const GET_DRS = 'GET_DRS';
export const GET_SPECIFIC_DR = 'GET_SPECIFIC_DR';
export const ASK_DR = 'ASK_DR';
export const ANSWER_DR = 'ANSWER_DR';
export const DELETE_DR = 'DELETE_DR';
export const CLEAR_DRS = 'CLEAR_DRS';
export const DRS_LOADING = 'DRS_LOADING';

export const GET_COMMISSION_HISTORIES = 'GET_COMMISSION_HISTORIES';
export const ADD_COMMISSION_HISTORY = 'ADD_COMMISSION_HISTORY';
export const EDIT_COMMISSION_HISTORY = 'EDIT_COMMISSION_HISTORY';
export const DELETE_COMMISSION_HISTORY = 'DELETE_COMMISSION_HISTORY';
export const CLEAR_COMMISSION_HISTORIES = 'CLEAR_COMMISSION_HISTORIES';
export const COMMISSION_HISTORIES_LOADING = 'COMMISSION_HISTORIES_LOADING';

export const GET_COMMISSION_BULLETINS = 'GET_COMMISSION_BULLETINS';
export const GET_SPECIFIC_COMMISSION_BULLETIN = 'GET_SPECIFIC_COMMISSION_BULLETIN';
export const ADD_COMMISSION_BULLETIN = 'ADD_COMMISSION_BULLETIN';
export const EDIT_COMMISSION_BULLETIN = 'EDIT_COMMISSION_BULLETIN';
export const DELETE_COMMISSION_BULLETIN = 'DELETE_COMMISSION_BULLETIN';
export const CLEAR_COMMISSION_BULLETINS = 'CLEAR_COMMISSION_BULLETINS';
export const CLEAR_COMMISSION_BULLETIN_CARD = 'CLEAR_COMMISSION_BULLETIN_CARD';
export const COMMISSION_BULLETINS_LOADING = 'COMMISSION_BULLETINS_LOADING';

export const GET_COMMISSION_PAYMENTS = 'GET_COMMISSION_PAYMENTS';
export const GET_SPECIFIC_COMMISSION_PAYMENT = 'GET_SPECIFIC_COMMISSION_PAYMENT';
export const ADD_COMMISSION_PAYMENT = 'ADD_COMMISSION_PAYMENT';
export const EDIT_COMMISSION_PAYMENT = 'EDIT_COMMISSION_PAYMENT';
export const DELETE_COMMISSION_PAYMENT = 'DELETE_COMMISSION_PAYMENT';
export const CLEAR_COMMISSION_PAYMENTS = 'CLEAR_COMMISSION_PAYMENTS';
export const CLEAR_COMMISSION_PAYMENT_CARD = 'CLEAR_COMMISSION_PAYMENT_CARD';
export const COMMISSION_PAYMENTS_LOADING = 'COMMISSION_PAYMENTS_LOADING';

export const GET_FORMULAS = 'GET_FORMULAS';
export const ADD_FORMULA = 'ADD_FORMULA';
export const DELETE_FORMULA = 'DELETE_FORMULA';
export const CLEAR_FORMULAS = 'CLEAR_FORMULAS';
export const FORMULAS_LOADING = 'FORMULAS_LOADING';

export const GET_FORMULA_INSTANCES = 'GET_FORMULA_INSTANCES';
export const ADD_OR_EDIT_FORMULA_INSTANCE = 'ADD_OR_EDIT_FORMULA_INSTANCE';
export const DELETE_FORMULA_INSTANCE = 'DELETE_FORMULA_INSTANCE';
export const CLEAR_FORMULA_INSTANCES = 'CLEAR_FORMULA_INSTANCES';
export const FORMULA_INSTANCES_LOADING = 'FORMULA_INSTANCES_LOADING';

export const GET_FORMULA_SOCIETE_DEFAULTS = 'GET_FORMULA_SOCIETE_DEFAULTS';
export const ADD_OR_EDIT_FORMULA_SOCIETE_DEFAULT = 'ADD_OR_EDIT_FORMULA_SOCIETE_DEFAULT';
export const DELETE_FORMULA_SOCIETE_DEFAULT = 'DELETE_FORMULA_SOCIETE_DEFAULT';
export const CLEAR_FORMULA_SOCIETE_DEFAULTS = 'CLEAR_FORMULA_SOCIETE_DEFAULTS';
export const FORMULA_SOCIETE_DEFAULTS_LOADING = 'FORMULA_SOCIETE_DEFAULTS_LOADING';

export const GET_GOALS = 'GET_GOALS';
export const ADD_OR_EDIT_GOAL = 'ADD_OR_EDIT_GOAL';
export const DELETE_GOAL = 'DELETE_GOAL';
export const CLEAR_GOALS = 'CLEAR_GOALS';
export const GOALS_LOADING = 'GOALS_LOADING';

export const GET_GOAL_SOCIETE_DEFAULTS = 'GET_GOAL_SOCIETE_DEFAULTS';
export const ADD_OR_EDIT_GOAL_SOCIETE_DEFAULT = 'ADD_OR_EDIT_GOAL_SOCIETE_DEFAULT';
export const DELETE_GOAL_SOCIETE_DEFAULT = 'DELETE_GOAL_SOCIETE_DEFAULT';
export const CLEAR_GOAL_SOCIETE_DEFAULTS = 'CLEAR_GOAL_SOCIETE_DEFAULTS';
export const GOAL_SOCIETE_DEFAULTS_LOADING = 'GOAL_SOCIETE_DEFAULTS_LOADING';

export const GET_BUDGETS = 'GET_BUDGETS';
export const ADD_OR_EDIT_BUDGET = 'ADD_OR_EDIT_BUDGET';
export const DELETE_BUDGET = 'DELETE_BUDGET';
export const CLEAR_BUDGETS = 'CLEAR_BUDGETS';
export const BUDGETS_LOADING = 'BUDGETS_LOADING';

export const GET_TOKENS = 'GET_TOKENS';
export const GET_SPECIFIC_TOKEN = 'GET_SPECIFIC_TOKEN';
export const EDIT_TOKEN = 'EDIT_TOKEN';
export const CLEAR_TOKENS = 'CLEAR_TOKENS';
export const TOKENS_LOADING = 'TOKENS_LOADING';

export const GET_LOGINLOGS = 'GET_LOGINLOGS';
export const CLEAR_LOGINLOGS = 'CLEAR_LOGINLOGS';
export const LOGINLOGS_LOADING = 'LOGINLOGS_LOADING';

export const GET_DIVISIONS = 'GET_DIVISIONS';
export const GET_SPECIFIC_DIVISION = 'GET_SPECIFIC_DIVISION';
export const ADD_DIVISIONS = 'ADD_DIVISIONS';
export const EDIT_DIVISION = 'EDIT_DIVISION';
export const ANSWER_DIVISION = 'ANSWER_DIVISION';
export const DELETE_DIVISION = 'DELETE_DIVISION';
export const CLEAR_DIVISIONS = 'CLEAR_DIVISIONS';
export const DIVISIONS_LOADING = 'DIVISIONS_LOADING';

export const GET_DIVISION_SAMPLES = 'GET_DIVISION_SAMPLES';
export const GET_SPECIFIC_DIVISION_SAMPLE = 'GET_SPECIFIC_DIVISION_SAMPLE';
export const ADD_DIVISION_SAMPLE = 'ADD_DIVISION_SAMPLE';
export const EDIT_DIVISION_SAMPLE = 'EDIT_DIVISION_SAMPLE';
export const DELETE_DIVISION_SAMPLE = 'DELETE_DIVISION_SAMPLE';
export const CLEAR_DIVISION_SAMPLES = 'CLEAR_DIVISION_SAMPLES';
export const DIVISION_SAMPLES_LOADING = 'DIVISION_SAMPLES_LOADING';

export const GET_DIVISION_PARTITION_TYPES = 'GET_DIVISION_PARTITION_TYPES';
export const GET_SPECIFIC_DIVISION_PARTITION_TYPE = 'GET_SPECIFIC_DIVISION_PARTITION_TYPE';
export const ADD_DIVISION_PARTITION_TYPE = 'ADD_DIVISION_PARTITION_TYPE';
export const EDIT_DIVISION_PARTITION_TYPE = 'EDIT_DIVISION_PARTITION_TYPE';
export const DELETE_DIVISION_PARTITION_TYPE = 'DELETE_DIVISION_PARTITION_TYPE';
export const CLEAR_DIVISION_PARTITION_TYPES = 'CLEAR_DIVISION_PARTITION_TYPES';
export const DIVISION_PARTITION_TYPES_LOADING = 'DIVISION_PARTITION_TYPES_LOADING';

export const GET_ENC_SORTIS = 'GET_ENC_SORTIS';
export const GET_SPECIFIC_ENC_SORTI = 'GET_SPECIFIC_ENC_SORTI';
export const ADD_ENC_SORTI = 'ADD_ENC_SORTI';
export const EDIT_ENC_SORTI = 'EDIT_ENC_SORTI';
export const ANSWER_ENC_SORTI = 'ANSWER_ENC_SORTI';
export const DELETE_ENC_SORTI = 'DELETE_ENC_SORTI';
export const CLEAR_ENC_SORTIS = 'CLEAR_ENC_SORTIS';
export const ENC_SORTIS_LOADING = 'ENC_SORTIS_LOADING';

export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const GET_SPECIFIC_NOTIFICATION = 'GET_SPECIFIC_NOTIFICATION';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const EDIT_NOTIFICATION = 'EDIT_NOTIFICATION';
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION';
export const CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS';
export const NOTIFICATIONS_LOADING = 'NOTIFICATIONS_LOADING';

export const GET_NOTIFICATION_MODELS = 'GET_NOTIFICATION_MODELS';
export const GET_SPECIFIC_NOTIFICATION_MODEL = 'GET_SPECIFIC_NOTIFICATION_MODEL';
export const ADD_NOTIFICATION_MODEL = 'ADD_NOTIFICATION_MODEL';
export const EDIT_NOTIFICATION_MODEL = 'EDIT_NOTIFICATION_MODEL';
export const DELETE_NOTIFICATION_MODEL = 'DELETE_NOTIFICATION_MODEL';
export const CLEAR_NOTIFICATION_MODELS = 'CLEAR_NOTIFICATION_MODELS';
export const NOTIFICATION_MODELS_LOADING = 'NOTIFICATION_MODELS_LOADING';

export const GET_RECU_REQS = 'GET_RECU_REQS';
export const GET_SPECIFIC_RECU_REQ = 'GET_SPECIFIC_RECU_REQ';
export const ADD_RECU_REQ = 'ADD_RECU_REQ';
export const EDIT_RECU_REQ = 'EDIT_RECU_REQ';
export const ANSWER_RECU_REQ = 'ANSWER_RECU_REQ';
export const DELETE_RECU_REQ = 'DELETE_RECU_REQ';
export const CLEAR_RECU_REQS = 'CLEAR_RECU_REQS';
export const RECU_REQS_LOADING = 'RECU_REQS_LOADING';

